import { ProductionJobType } from "../enums/production-job-type";
import { CellMetric } from "./metric-base";

export class MetricRunningTotal {

    // Subassembly 2283
    public METRIC_SA_2283_AW : CellMetric   = new CellMetric(ProductionJobType.SectionSubassembly83AccentWindows);
    public METRIC_SA_2283_AD : CellMetric   = new CellMetric(ProductionJobType.SectionSubassembly83AccentDoors);
    public METRIC_SA_2283_W : CellMetric    = new CellMetric(ProductionJobType.SectionSubassembly83Windows);
    public METRIC_SA_2283_OW : CellMetric   = new CellMetric(ProductionJobType.SectionSubassembly83OverlayWindows);
    public METRIC_SA_2283_OD : CellMetric   = new CellMetric(ProductionJobType.SectionSubassembly83OverlayDoors);
    
    // Subassembly Rib
    public METRIC_SA_RIB_W : CellMetric     = new CellMetric(ProductionJobType.SectionSubassemblyRibWindows);

    public METRIC_SA_FR_90 : CellMetric     = new CellMetric(ProductionJobType.SectionSubassemblyFR90);

    public METRIC_SA_FIP : CellMetric       = new CellMetric(ProductionJobType.SectionSubassemblyFIP);
    
    // Print
    public METRIC_PRINT : CellMetric        = new CellMetric(ProductionJobType.SectionPrint);
    public METRIC_PRINT_W : CellMetric      = new CellMetric(ProductionJobType.SectionPrintWindows);
    public METRIC_PRINT_D : CellMetric      = new CellMetric(ProductionJobType.SectionPrintDoors);
    
    // Windows
    public METRIC_WIN_RP : CellMetric       = new CellMetric(ProductionJobType.WindowCutoutRaisedPanel);
    public METRIC_WIN_83 : CellMetric       = new CellMetric(ProductionJobType.WindowCutoutEightyThree);
    public METRIC_WIN_FP : CellMetric       = new CellMetric(ProductionJobType.WindowCutoutFoamPack);
    public METRIC_WIN_AP : CellMetric       = new CellMetric(ProductionJobType.WindowCutoutAccentPack);
    public METRIC_WIN_RIB : CellMetric      = new CellMetric(ProductionJobType.WindowCutoutRib);

    // Section Assembly
    public METRIC_ASM_RP : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyRP);
    public METRIC_ASM_83 : CellMetric       = new CellMetric(ProductionJobType.SectionAssembly83);
    public METRIC_ASM_FP : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyFP);
    public METRIC_ASM_AP : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyAP);
    public METRIC_ASM_RB : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyRB);
    public METRIC_ASM_FV : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyFV);
    public METRIC_ASM_CH : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyCH);
    public METRIC_ASM_I : CellMetric       = new CellMetric(ProductionJobType.SectionAssemblyI);

    // Section Loading
    public METRIC_LOAD_SEC : CellMetric     = new CellMetric(ProductionJobType.SectionLoading);

    // Hardawre Subassembly
    public METRIC_TR_RES : CellMetric       = new CellMetric(ProductionJobType.TrackSubassemblyResidential);
    public METRIC_TR_COMM : CellMetric      = new CellMetric(ProductionJobType.TrackSubassemblyCommercial);
    public METRIC_TR_LHR : CellMetric       = new CellMetric(ProductionJobType.TrackSubassemblyLHR);

    //Spring Subassembly
    public METRIC_SPRINGS_RES: CellMetric = new CellMetric(ProductionJobType.SpringSubassemblyResidential);
    public METRIC_SPRINGS_COMM: CellMetric = new CellMetric(ProductionJobType.SpringSubassemblyCommercial);

    public METRIC_STRUTS : CellMetric       = new CellMetric(ProductionJobType.StrutSubassembly);
    public METRIC_HW : CellMetric           = new CellMetric(ProductionJobType.HardwareSubassembly);

    // Needed for building the table
    public METRIC_SPACER : CellMetric       = new CellMetric(ProductionJobType.NotApplicable);


    public METRIC_LIST = [
        // Subassembly 2283
        this.METRIC_SA_2283_W,
        this.METRIC_SA_2283_OW,
        this.METRIC_SA_2283_OD,
        this.METRIC_SA_FR_90,
        // Subassembly Rib
        this.METRIC_SA_RIB_W,
        // Subassembly Foam Room
        this.METRIC_SA_FIP,
        // Print
        this.METRIC_PRINT_W,
        this.METRIC_PRINT_D,
        // Windows
        this.METRIC_WIN_RP,
        this.METRIC_WIN_83,
        this.METRIC_WIN_FP,
        this.METRIC_WIN_AP,
        this.METRIC_WIN_RIB,
        // Section Assembly
        this.METRIC_ASM_RP,
        this.METRIC_ASM_83,
        this.METRIC_ASM_FP,
        this.METRIC_ASM_AP,
        this.METRIC_ASM_RB,
        this.METRIC_ASM_FV,
        this.METRIC_ASM_CH,
        this.METRIC_ASM_I,

        // Section Loading
        this.METRIC_LOAD_SEC,
        this.METRIC_SPACER,

        // Hardawre Subassembly
        this.METRIC_TR_RES,
        this.METRIC_TR_COMM,
        this.METRIC_TR_LHR,
        this.METRIC_SPRINGS_RES,
        this.METRIC_SPRINGS_COMM,
        this.METRIC_STRUTS,
        this.METRIC_HW
    ];
    
    // Subassembly
    public getMETRIC_SA_2283_AW     = () => this.METRIC_SA_2283_AW.quantity;
    public getMETRIC_SA_2283_AD     = () => this.METRIC_SA_2283_AD.quantity;
    public getMETRIC_SA_2283_W      = () => this.METRIC_SA_2283_W.quantity;
    public getMETRIC_SA_2283_OW     = () => this.METRIC_SA_2283_OW.quantity;
    public getMETRIC_SA_2283_OD     = () => this.METRIC_SA_2283_OD.quantity;
    public getMETRIC_SA_RIB_W       = () => this.METRIC_SA_RIB_W.quantity;
    public getMETRIC_SA_FR_90       = () => this.METRIC_SA_FR_90.quantity;
    public getMETRIC_SA_FIP         = () => this.METRIC_SA_FIP.quantity;
    public getMETRIC_PRINT          = () => this.METRIC_PRINT.quantity;
    public getMETRIC_PRINT_W        = () => this.METRIC_PRINT_W.quantity;
    public getMETRIC_PRINT_D        = () => this.METRIC_PRINT_D.quantity;
    public getMETRIC_WIN_RP         = () => this.METRIC_WIN_RP.quantity;
    public getMETRIC_WIN_83         = () => this.METRIC_WIN_83.quantity;
    public getMETRIC_WIN_FP         = () => this.METRIC_WIN_FP.quantity;
    public getMETRIC_WIN_AP         = () => this.METRIC_WIN_AP.quantity;
    public getMETRIC_WIN_RIB        = () => this.METRIC_WIN_RIB.quantity;
    public getMETRIC_ASM_RP         = () => this.METRIC_ASM_RP.quantity;
    public getMETRIC_ASM_83         = () => this.METRIC_ASM_83.quantity;
    public getMETRIC_ASM_FP         = () => this.METRIC_ASM_FP.quantity;
    public getMETRIC_ASM_AP         = () => this.METRIC_ASM_AP.quantity;
    public getMETRIC_ASM_RB         = () => this.METRIC_ASM_RB.quantity;
    public getMETRIC_ASM_FV         = () => this.METRIC_ASM_FV.quantity;
    public getMETRIC_ASM_CH         = () => this.METRIC_ASM_CH.quantity;
    public getMETRIC_ASM_I          = () => this.METRIC_ASM_I.quantity;
    public getMETRIC_LOAD_SEC       = () => this.METRIC_LOAD_SEC.quantity;
    public getMETRIC_TR_RES         = () => this.METRIC_TR_RES.quantity;
    public getMETRIC_TR_COMM        = () => this.METRIC_TR_COMM.quantity;
    public getMETRIC_TR_LHR         = () => this.METRIC_TR_LHR.quantity;
    public getMETRIC_SPRINGS_RES    = () => this.METRIC_SPRINGS_RES.quantity;
    public getMETRIC_SPRINGS_COMM   = () => this.METRIC_SPRINGS_COMM.quantity;
    public getMETRIC_STRUTS         = () => this.METRIC_STRUTS.quantity;
    public getMETRIC_HW             = () => this.METRIC_HW.quantity;
    public getMETRIC_SPACER         = () => -1;
}